import { render } from "./MtnZambia.vue?vue&type=template&id=31a8bac8&scoped=true"
import script from "./MtnZambia.vue?vue&type=script&lang=js"
export * from "./MtnZambia.vue?vue&type=script&lang=js"

import "./MtnZambia.vue?vue&type=style&index=0&id=31a8bac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a8bac8"]])

export default __exports__